import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { PresupuestoseditComponent } from './modal/presupuestosedit/presupuestosedit.component';
import { LlenardatosComponent } from './modal/llenardatos/llenardatos.component';
import { VerimagenComponent } from './modal/verimagen/verimagen.component';
import { MeasureCalculatorComponent } from './modal/measure-calculator/measure-calculator.component';
import { ImageEditorComponent } from './modal/image-editor/image-editor.component';
import { ItemDetailsComponent } from './modal/item-details/item-details.component';
import { GaleriaTrabajosComponent } from './modal/galeria-trabajos/galeria-trabajos.component';
import { ImageAuthPipe } from './pipes/image-auth-pipe';
import { InformeFotograficoComponent } from './modal/informe-fotografico/informe-fotografico.component';



import { InspecdatosareaComponent } from './modal/inspecdatosarea/inspecdatosarea.component';
import { InspecdatosareamedidasComponent } from './modal/inspecdatosareamedidas/inspecdatosareamedidas.component';
import { PlanillaCalendarComponent } from './modal/planilla-calendar/planilla-calendar.component';
import { WorkerSelectorComponent } from './modal/worker-selector/worker-selector.component';
import { EditActivityComponent } from './modal/edit-activity/edit-activity.component';
import { GastoseditComponent } from './modal/gastosedit/gastosedit.component';
import { GastosFormModalComponent } from './modal/gastosedit/gastos-form-modal.component';
import { OclinkComponent } from './modal/oclink/oclink.component';
import { InspecdatosareaestimadoComponent } from './modal/inspecdatosareaestimado/inspecdatosareaestimado.component';
import { InspecdatosareaestimadoeditComponent } from './modal/inspecdatosareaestimadoedit/inspecdatosareaestimadoedit.component';
import { GenerarPagoComponent } from './modal/generar-pago/generar-pago.component';
import { EditmodalComponent } from './modal/editmodal/editmodal.component';
import { HelpiaComponent } from './modal/helpia/helpia.component';
import { DashboardRecordsModalComponent } from './modal/dashboard-records-modal/dashboard-records-modal.component';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AppIdInterceptor } from './interceptors/auth.interceptor';

registerLocaleData(localeEs, 'es-ES');

@NgModule({
  declarations: [AppComponent, PresupuestoseditComponent, LlenardatosComponent, VerimagenComponent, MeasureCalculatorComponent, ImageEditorComponent,
    ItemDetailsComponent, GaleriaTrabajosComponent, ImageAuthPipe, InspecdatosareaComponent, InspecdatosareamedidasComponent,
    PlanillaCalendarComponent, WorkerSelectorComponent, EditActivityComponent, GastoseditComponent,
    GastosFormModalComponent, OclinkComponent, InspecdatosareaestimadoComponent, InspecdatosareaestimadoeditComponent, GenerarPagoComponent,
    InformeFotograficoComponent, EditmodalComponent, HelpiaComponent, DashboardRecordsModalComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  { provide: HTTP_INTERCEPTORS, useClass: AppIdInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
